var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHorseDefaultAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.1462 7C29.1462 7 28.6524 8.41669 28.7028 9.55402C28.7532 10.6914 29.1462 12.3774 29.1462 12.3774C29.1462 12.3774 30.2952 13.415 31.7869 17.0565C33.2686 20.698 33.4903 21.5659 33.4903 21.5659C33.4903 21.5659 35.6371 23.9005 34.8107 25.7561C33.9842 27.6018 32.3917 28.37 30.7992 27.7714C29.2067 27.1728 29.2571 25.5466 29.2571 25.5466C29.2571 25.5466 27.9368 25.387 26.2334 24.2397C24.53 23.0924 23.381 21.4163 23.381 21.4163C23.381 21.4163 19.5309 24.0701 21.3451 28.5795C23.1593 33.089 25.2457 34.6653 24.7518 37.8778C24.2579 41.0902 24.0362 41.2997 24.0362 41.2997C24.0362 41.2997 0.331803 45.992 -5 39.7865C-1.45641 30.2926 6.95224 21.4063 6.95224 21.4063L3.606 22.9227C3.606 22.9227 3.55561 18.3534 9.09907 13.7342C14.6425 9.11505 18.8152 9.16493 21.2342 9.27468C23.6532 9.38442 25.0239 10.0329 25.0239 10.0329C25.0239 10.0329 25.8504 8.08746 29.1462 7Z",
    fill: "#DEDFE1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorseDefaultAvatar);
export default __webpack_public_path__ + "static/media/horse-default-avatar.a9cf43eb.svg";
export { ForwardRef as ReactComponent };